import { useAppContext } from "context/AppContext";
import { useModal } from "context/ModalContext/Modal.context";
import { useEffect, useRef, useState } from "react";
import { setStorageItem } from "utils/storage";

import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import SwiperCore, { Swiper as swiper } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Step, Tutorial } from "types/tutorial";
import { useAuth } from "context/AuthContext";
import { NavigationOptions } from "swiper/types/modules/navigation";

import "./style.scss";
import { useNavigate } from "react-router";
import { getTutorial } from "services/tutorial.service";

interface Options {
  onlyClose?: boolean;
  tutorial_id: string;
}

const ModalTutorial = ({ onlyClose, tutorial_id }: Options) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const { showModal, closeModal } = useModal();
  const [tutorialDetail, getTutorialDetail] = useState<Tutorial>();
  const swiperRef = useRef<SwiperCore | null>(null);
  const [isLast, setIsLast] = useState(false);

  const refPrev = useRef<HTMLButtonElement>(null);
  const refNext = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (tutorialDetail && tutorialDetail.steps.length === 1) {
      setIsLast(true);
    }
  }, [tutorialDetail]);

  const getTutorialInfo = async (_id: string) => {
    try {
      const tutorial = await getTutorial(_id);
      getTutorialDetail(tutorial);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    getTutorialInfo(tutorial_id);
  }, [tutorial_id]);

  const onClose = () => {
    setStorageItem("check_tutorial", "true");
    closeModal();
    if (!onlyClose) {
      navigate("/realizations");
    }
  };

  if (!tutorialDetail?.steps || tutorialDetail.steps.length === 0) {
    return null; // Or show a fallback message
  }

  return (
    <div className="p-2 bg-white rounded-lg md:p-8">
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        onSwiper={(swiper: SwiperCore) => {
          swiperRef.current = swiper;
          if (swiper.params.navigation) {
            (swiper.params.navigation as NavigationOptions).prevEl =
              refPrev.current;
            (swiper.params.navigation as NavigationOptions).nextEl =
              refNext.current;
            swiper.navigation.update();
          }
        }}
        onSlideChange={(swiper: SwiperCore) => {
          console.log({
            st: tutorialDetail.steps.length,
            c: swiper.activeIndex,
          });
          setCurrentIndex(swiper.activeIndex);
          if (
            tutorialDetail.steps.length - 1 === swiper.activeIndex ||
            tutorialDetail.steps.length === 1
          ) {
            setIsLast(true);
          } else {
            setIsLast(false);
          }
          console.log(swiper);
        }}
      >
        {tutorialDetail?.steps.map((item: Step, index: number) => (
          <SwiperSlide key={index}>
            <div
              className="inner-content"
              dangerouslySetInnerHTML={{ __html: item.text }}
            ></div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="flex items-center justify-center gap-8 actions">
        {currentIndex == 0 && !isLast ? (
          <button
            ref={refPrev}
            onClick={(e) => swiperRef.current?.slideNext()}
            className="btn bg-yellow-bb text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
          >
            iniciar tutorial
          </button>
        ) : (
          <>
            {!isLast && (
              <button
                ref={refPrev}
                onClick={(e) => swiperRef.current?.slidePrev()}
                className="bg-gray-bb-6 text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
              >
                Voltar
              </button>
            )}
            <button
              ref={refNext}
              onClick={(e) => {
                if (isLast) {
                  onClose();
                } else {
                  swiperRef.current?.slideNext();
                }
              }}
              className="btn bg-yellow-bb text-blue-bb-1 rounded-[4px] py-3 px-4 font-bb font-bold uppercase"
            >
              {isLast ? "Fechar" : "Continuar"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalTutorial;
